export default "__VITE_ASSET__CxjEG6EB__"